// import React, { useState, useEffect, useMemo } from "react"
// import lodash from "lodash"
// import styled from "styled-components"

// const Wrapper = styled.div``

// const Timings = props => {
//   const { product, isPickup, isPickupProduct } = props

//   const { isMixedTransport } = useTransport()

//   return <Wrapper>Timings</Wrapper>
// }

// export default Timings
